<template>
  <!-- 手机端头部，保持与电脑端一致的布局 -->
  <header v-if="!isDesktop" class="header-component">
    <div class="header-content">
      <!-- 左侧部分 -->
      <div class="header-left">
        <!-- 手机端菜单按钮 -->
        <div class="menu-toggle" @click="toggleMenu">
          <i class="el-icon-menu"></i>
        </div>
        <!-- 手机端共享的 logo -->
        <div class="logo">
          <div class="logo-container">
            <van-image
              src="https://cdn.cxc-group.com/manage/logo2.png" alt="logo" class="logo-image"
            />
          </div>
        </div>
      </div>
      
      <!-- 中间部分，仅电脑端显示 -->
      <div class="header-middle"></div>
      
      <!-- 右侧用户信息 -->
      <div class="header-right">
        <!-- 用户信息和下拉菜单 -->
        <el-dropdown trigger="click">
          <div class="user-info">
            <el-avatar size="small" :src="userAvatar"></el-avatar>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- 通知选项 -->
            <el-dropdown-item @click.native="handleNotification">
              <i class="el-icon-bell"></i>
              <span>通知</span>
              <el-badge :value="3" class="item" style="margin-left: auto;"></el-badge>
            </el-dropdown-item>
            
            <!-- 消息选项 -->
            <el-dropdown-item @click.native="handleMessage">
              <i class="el-icon-message"></i>
              <span>消息</span>
              <el-badge :value="5" class="item" style="margin-left: auto;"></el-badge>
            </el-dropdown-item>
            
            <!-- 分隔线 -->
            <el-dropdown-item divided></el-dropdown-item>
            
            <!-- 通用选项 -->
            <el-dropdown-item @click.native="handlePersonalCenter">
              <i class="el-icon-user"></i>
              <span>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleSettings">
              <i class="el-icon-setting"></i>
              <span>设置</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="handleLogout">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>
  
  <!-- 电脑端使用原有结构 -->
  <header v-else class="header-component">
    <div class="header-content">
      <!-- 左侧部分 -->
      <div class="header-left">
        <!-- 电脑端和手机端共享的 logo -->
        <div class="logo">
          <div class="logo-container">
            <el-image src="https://cdn.cxc-group.com/manage/logo2.png" alt="logo" class="logo-image"></el-image>
          </div>
        </div>
      </div>
      
      <!-- 中间部分，仅电脑端显示 -->
      <div class="header-middle"></div>
      
      <!-- 右侧用户信息 -->
      <div class="header-right">
        <!-- 通知图标 -->
        <div class="header-icon-item">
          <el-badge :value="3" class="item">
            <i class="el-icon-bell"></i>
          </el-badge>
        </div>
        
        <!-- 分隔线 -->
        <div class="header-divider"></div>
        
        <!-- 消息图标 -->
        <div class="header-icon-item">
          <el-badge :value="5" class="item">
            <i class="el-icon-message"></i>
          </el-badge>
        </div>
        
        <!-- 分隔线 -->
        <div class="header-divider"></div>
        
        <!-- 用户信息和下拉菜单 -->
        <el-dropdown trigger="click">
          <div class="user-info">
            <el-avatar size="small" :src="userAvatar"></el-avatar>
            <span class="user-name">{{ userName }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- 通用选项 -->
            <el-dropdown-item @click.native="handlePersonalCenter">
              <i class="el-icon-user"></i>
              <span>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="handleSettings">
              <i class="el-icon-setting"></i>
              <span>设置</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="handleLogout">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    isDesktop: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // 从Vuex store中获取用户名
    userName() {
      return this.$store.getters.getUserName || '管理员'
    },
    // 从Vuex store中获取用户头像
    userAvatar() {
      return this.$store.getters.getUserAvatar || ''
    }
  },
  methods: {
    toggleMenu() {
      this.$emit('toggle-menu')
    },
    // 处理通知点击事件
    handleNotification() {
      // 这里可以添加通知点击后的逻辑
      console.log('通知点击')
    },
    // 处理消息点击事件
    handleMessage() {
      // 这里可以添加消息点击后的逻辑
      console.log('消息点击')
    },
    // 处理个人中心点击事件
    handlePersonalCenter() {
      // 跳转到个人中心页面
      this.$router.push('/mine')
    },
    // 处理设置点击事件
    handleSettings() {
      // 这里可以添加设置点击后的逻辑
      console.log('设置点击')
    },
    // 处理退出登录点击事件
    handleLogout() {
      // 这里可以添加退出登录点击后的逻辑
      console.log('退出登录点击')
      // 调用Vuex store的退出登录方法
      this.$store.dispatch('logout')
      // 跳转到登录页
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */

/* 头部基础样式 */
.header-component {
  background-color: white;
  color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 80px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 头部内容容器 */
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}

/* 电脑端样式：左右两边贴近边缘 */
@media (min-width: 769px) {
  .header-content {
    max-width: none;
    margin: 0;
    padding: 0 30px;
  }
}

/* 左侧部分 */
.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* 菜单按钮 */
.menu-toggle {
  font-size: 24px;
  cursor: pointer;
  color: #666;
  transition: opacity 0.3s;
}

.menu-toggle:hover {
  opacity: 0.8;
  color: #a67c52;
}

/* Logo 基础样式 */
.logo {
  display: flex;
  align-items: center;
}

/* Logo 容器 */
.logo-container {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 40px;
}
.logo-image {
  height: 40px;
}

/* Logo 图标 */
.logo-icon {
  width: 40px;
  height: 40px;
  background-color: #a67c52;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
}

/* Logo 图标内部的线条 */
.logo-icon::before,
.logo-icon::after {
  content: '';
  position: absolute;
  background-color: white;
  border-radius: 50%;
}

/* 左侧半圆 */
.logo-icon::before {
  width: 30px;
  height: 30px;
  top: 5px;
  left: 0;
  border: 5px solid #a67c52;
  border-right-color: transparent;
}

/* 右侧半圆 */
.logo-icon::after {
  width: 20px;
  height: 20px;
  top: 5px;
  right: 0;
  border: 5px solid #a67c52;
  border-left-color: transparent;
}

/* Logo 文字部分 */
.logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

/* 中文名称 */
.logo-chinese {
  font-size: 18px;
  font-weight: 700;
  color: #a67c52;
  line-height: 1;
  margin: 0;
}

/* 英文名称，仅电脑端显示 */
.logo-english {
  font-size: 10px;
  font-weight: 500;
  color: #a67c52;
  line-height: 1;
  margin: 2px 0 0 0;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* 中间部分 */
.header-middle {
  flex: 1;
}

/* 右侧部分 */
.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* 图标项样式，仅电脑端显示 */
.header-icon-item {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  transition: opacity 0.3s;
}

.header-icon-item:hover {
  opacity: 0.8;
  color: #a67c52;
}

/* 分隔线样式，仅电脑端显示 */
.header-divider {
  width: 1px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 0 5px;
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #333;
  font-size: 14px;
  transition: opacity 0.3s;
}

.user-info:hover {
  opacity: 0.8;
  color: #a67c52;
}

.user-info i {
  font-size: 14px;
  color: #666;
}

/* 用户头像样式 */
.user-info .el-avatar {
  width: 30px;
  height: 30px;
  background-color: #f5f5f5;
  color: #666;
  font-size: 14px;
}

/* 用户名样式，仅电脑端显示 */
.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

/* 响应式调整 */
@media (max-width: 768px) {
  /* 手机端英文名称不显示 */
  .logo-english {
    display: none;
  }
  
  /* 手机端头像右侧只显示箭头 */
  .user-info {
    gap: 5px;
  }
}
</style>